import { render, staticRenderFns } from "./ShareReport.vue?vue&type=template&id=e0965768&"
import script from "./ShareReport.vue?vue&type=script&lang=js&"
export * from "./ShareReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports